"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangesPropertyUse = void 0;
class ChangesPropertyUse {
}
exports.ChangesPropertyUse = ChangesPropertyUse;
//# sourceMappingURL=ChangesPropertyUse.js.map